function _(t,n,i){var r=t(10);n.exports=function(){return r(this).length=0,this}}
//# sourceMappingURL=clear.min.js.map